import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberKey } from '../../utils/keys';
import { useCachedMember } from '../cache';
export const useMember = (options) => {
    const { id, fields = 'default', useQueryOptions } = options;
    const { client } = useTribeClient();
    const memberKey = getMemberKey({ id });
    const memberPlaceHolder = useCachedMember(id);
    return useQuery(memberKey, () => client.members.get(id, fields), {
        placeholderData: () => memberPlaceHolder,
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useMember.js.map